import React, { useContext, useState } from "react";
import { DatePicker, Input } from "antd";
import TablePage from "../components/TablePage";
import dayjs from "dayjs";
import axiosInstance from "../common/api";
import { date2locale } from "../common/common";
import NewAttendanceJustificationBatch from "../attendancejustification/NewAttendanceJustificationBatch";
import EditJustification from "./EditJustification";
import { UserInfoContext } from "../FetchUserInfo";
import { Outlet, useNavigate } from "react-router-dom";

const columns = [
    {
        title: "Dipendente",
        dataIndex: ["employee", "fullName"],
        width: 200,
    },
    {
        title: "Data",
        dataIndex: "date",
        width: 100,
        key: "date",
        render: (x) => dayjs(x).format("DD/MM/YYYY"),
    },
    {
        title: "Giustificativo",
        key: "justificationType",
        width: 150,
        dataIndex: ["justificationType", "name"],
    },
    {
        title: "Ore",
        key: "minutes",
        width: 100,
        dataIndex: "minutes",
        render: (x) => dayjs.duration(x, "minutes").format("HH:mm"),
    },
    {
        title: "Richiesta",
        key: "leaveRequest",
        width: 300,
        dataIndex: "leaveRequestProcessInstanceId",
    },
];

const fetchData = (params) => {
    if (params.date) {
        params.startDate = params.date.split("_")[0];
        params.endDate = params.date.split("_")[1];
        delete params.date;
    }
    return axiosInstance
        .get("justification", {
            params,
            paramsSerializer: { indexes: null },
        })
        .then(({ data, ...props }) => ({
            data: {
                ...data,
                data: data.data.map((x) => ({
                    ...x,
                    id: `${x.employee.id}_${x.justificationType.id}_${x.date}`,
                })),
            },
            ...props,
        }));
};
export default function () {
    const [newJOpen, setNewJOpen] = useState(false);
    const [editItem, setEditItem] = useState();
    const [editOpen, setEditOpen] = useState(false);
    const navigate = useNavigate();
    const user = useContext(UserInfoContext);

    return (
        <div style={{ display: "flex", flexDirection: "column", rowGap: 16 }}>
            {/* <EditJustification
                data={editItem}
                onCancel={() => {
                    setEditItem();
                }}
                onFinish={() => {
                    setEditItem();
                    fetchData();
                }}
            />*/}
            <Outlet />
            <TablePage
                rowSelectionType="radio"
                fetchFunction={fetchData}
                columns={columns}
                toolbarProps={(refresh) => ({
                    addAction: user.permissions?.includes("justification.create")
                        ? () => setNewJOpen(true)
                        : null,

                    editAction: user.permissions?.includes("justification.update")
                        ? (key) => {
                              setEditItem(key);
                              setEditOpen(true);
                          }
                        : null,

                    deleteAction: user.permissions?.includes("justification.update")
                        ? (keys) =>
                              axiosInstance
                                  .delete(`justification/${keys[0]}`)
                                  .finally(() => refresh())
                        : null,
                })}
                filterItems={[
                    {
                        name: "query",
                        label: "Dipendente",
                        formItem: {
                            children: <Input />,
                        },
                    },
                    {
                        name: "date",
                        label: "Data",
                        readableValue: (value) =>
                            `Dal ${date2locale(value.split("_")[0])} al ${date2locale(value.split("_")[1])}`,
                        formItem: {
                            children: (
                                <DatePicker.RangePicker
                                    style={{ width: "100%" }}
                                    format="DD/MM/YYYY"
                                />
                            ),
                            props: {
                                getValueProps: (value) => ({
                                    value: value
                                        ? [dayjs(value.split("_")[0]), dayjs(value.split("_")[1])]
                                        : [],
                                }),
                                normalize: (value) =>
                                    value.length === 2 &&
                                    value[0].format("YYYY-MM-DD") +
                                        "_" +
                                        value[1].format("YYYY-MM-DD"),
                            },
                        },
                    },
                ]}
            >
                {(refresh) => (
                    <>
                        <NewAttendanceJustificationBatch
                            open={newJOpen}
                            onCancel={() => setNewJOpen(false)}
                            onFinish={() => {
                                setNewJOpen(false);
                                refresh();
                            }}
                        />
                        <EditJustification
                            id={editItem}
                            open={editOpen}
                            onCancel={() => {
                                setEditOpen(false);
                            }}
                            onFinish={() => {
                                setEditItem();
                                setEditOpen(false);
                                refresh();
                            }}
                        />
                    </>
                )}
            </TablePage>
        </div>
    );
}
